import { FunctionComponent } from 'react';
import HeaderSection from '../../components/sections/HeaderSection/HeaderSection';
import BaseSection from '../../components/sections/BaseSection/BaseSection';
import EventCard from '../../components/blocks/EventCard/EventCard';
import TablematesBlock from '../../components/blocks/TablematesBlock/TablematesBlock';
import styles from './PreferencesView.module.scss';
import RestaurantDetailsBlock from '../../components/blocks/RestaurantDetailsBlock/RestaurantDetailsBlock';
import MapBlock from '../../components/blocks/MapBlock/MapBlock';
import MetaTags from '../../../../components/seo/MetaTags/MetaTags';
import { NavLink, Outlet } from 'react-router-dom';
import { RoutesGrouped } from '../../../../data/routes';
import RoutesEnum from '../../../../enums/routes';
import classNames from 'classnames';

interface PreferencesViewProps {}

const PreferencesView: FunctionComponent<PreferencesViewProps> = () => {
  return (
    <>
      <MetaTags title="Constellation Dinners - Preferences" hideMainTitle={true} />

      <HeaderSection title={`Preferences`} elementsToHide={['Avatar']} />

      <BaseSection>
        <nav className={styles['nav']}>
          <ul>
            <li>
              <NavLink
                className={classNames('text text--body-2 text--bold')}
                to={`/${RoutesGrouped.CONSTELLATION_DINNERS_BASE}/${RoutesEnum.PREFERENCES}/${RoutesEnum.GENERAL}`}
              >
                General
              </NavLink>
            </li>

            <li>
              <NavLink
                className={classNames('text text--body-2 text--bold')}
                to={`/${RoutesGrouped.CONSTELLATION_DINNERS_BASE}/${RoutesEnum.PREFERENCES}/${RoutesEnum.DINING_PREFERENCES}`}
              >
                Dinning Preferences
              </NavLink>
            </li>
          </ul>
        </nav>

        <main className={styles['main']}>
          <Outlet />
        </main>
      </BaseSection>
    </>
  );
};

export default PreferencesView;
